export const checkSavedCartItemsRemoveAbility = (orders, isTestCompany) => {
	const notCanceledSavedItemsCount = orders.reduce((itemsCount, order) => {
		if (order.id) {
			const validItems = order.items.filter(item => !['CANCELED', 'PREPARED_TO_CANCEL'].includes(item?.status))
			return itemsCount + validItems.length
		}
		return itemsCount
	}, 0)

	return isTestCompany ? notCanceledSavedItemsCount > 0 : notCanceledSavedItemsCount > 1
}
